import jwt from 'jsonwebtoken';
import cryptoJs from 'crypto-js';
import { getAse } from './env';
/**
 * 解密token
 * @param access_sign
 * @returns
 */
export const jwtDecode = (access_sign) => {
    const aseKey = getAse();
    //解密
    const decrypt = cryptoJs.AES.decrypt(decodeURIComponent(access_sign), cryptoJs.enc.Utf8.parse(aseKey), {
        mode: cryptoJs.mode.ECB,
        padding: cryptoJs.pad.Pkcs7,
    }).toString(cryptoJs.enc.Utf8);
    const data = jwt.decode(decrypt) || {};
    return {
        decrypt,
        jwtDecodeData: data,
        aseKey,
    };
};
